<template>
  <div v-bind:class="amplifyUI.formSection" class="login-form forgot">
    <div v-bind:class="amplifyUI.sectionHeader">{{options.header}}
        <!-- <div v-bind:class="amplifyUI.hint" class="mt-1" v-if="!mersBranded">
          {{$Amplify.I18n.get('Forgot your password? ')}}
          <a
            v-bind:class="amplifyUI.a"
            v-on:click="$router.push('/resetpassword')"
          >{{$Amplify.I18n.get('Reset password')}}</a>
        </div>
        <div v-bind:class="amplifyUI.hint" class="mt-1" v-else>
          <a
            v-bind:class="amplifyUI.a"
            v-on:click="$router.push('/resetpassword')"
          >{{$Amplify.I18n.get('Forgot password?')}}</a>
        </div> -->
    </div>
    <div v-bind:class="amplifyUI.sectionBody">
      <div v-bind:class="amplifyUI.formField">
        <div v-bind:class="amplifyUI.inputLabel">{{$Amplify.I18n.get('Email')}}</div>
        <input
          v-bind:class="amplifyUI.input"
          v-model="email"
          aria-label="email"
          :placeholder="$Amplify.I18n.get('Enter your email')"
          autofocus
          @keyup.enter="submit"
        />
      </div>
    </div>
    <div v-bind:class="amplifyUI.sectionFooter">
      <span v-bind:class="amplifyUI.sectionFooterPrimaryContent">
        <a class="lht-blue mr-5" v-on:click="$router.push('/')">Return to log in</a>
        <v-btn
          v-bind:class="amplifyUI.button"
          v-on:click="submit"
          :loading="buttonLoad"
          dark
          depressed
          :color="appButtonColor"
          large
          class="ma-0 load-button"
        >{{$Amplify.I18n.get('Send Username')}}</v-btn>
      </span>
    </div>
    <div class="forgotError" v-if="error">{{ error }}</div>
  </div>
</template>

<script>
import { AmplifyEventBus } from "aws-amplify-vue";
import * as AmplifyUI from "@aws-amplify/ui";
import { mapState } from "vuex";
export default {
  name: "ForgotUsername",
  data() {
    return {
      email: "",
      buttonLoad: false,
      error: "",
      logger: {},
      amplifyUI: AmplifyUI
    };
  },
  computed: {
    ...mapState("user", [
      "resetUser",
      "retirementBranded",
      "retirementBrandedTitle",
      "mersBranded",
      "mersBrandedTitle"
    ]),
    appButtonColor() {
      return this.mersBranded ? "#33715A" : "#0C2B4A";
    },
    options() {
      const defaults = {
        header: "Forgot Username?"
      }
      return Object.assign(defaults, {});
    }
  },
  mounted() {
    this.logger = new this.$Amplify.Logger(this.$options.name);
  },
  methods: {
    checkEmail(val) {
      return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(val) ? true : false
    },
    async submit() {
      if (!this.checkEmail(this.email) || !this.email) return
      this.error = ""
      this.buttonLoad = true
      await this.$store.dispatch("user/getUserName", JSON.stringify({
        email: this.email,
        mers: this.mersBranded
      }))
      this.error = `Account details have been sent to email requested.`
      this.email = ""
      this.buttonLoad = false
    },
    setError: function(e) {
      this.error = this.$Amplify.I18n.get(e.message || e);
      this.logger.error(this.error);
    }
  }
};
</script>

<style lang="scss" scoped>
  .main-box {
    .Section__sectionHeader___2djyg {
      margin-bottom: .5rem;
    }
  }
</style>

<style lang="scss">
.login-form input {
  border: 1px solid lightgray;
}
.forgotError {
  color: red;
  margin-top: 1rem;
}
.bottom-margin {
  margin-bottom: 10px;
}
.mers {
  .forgot {
    .Section__sectionFooterPrimaryContent___2r9ZX {
      align-items: center;
      display: flex;
    }
  }
}
</style>
